import { render, staticRenderFns } from "./MinistryLog.vue?vue&type=template&id=2675521b&"
import script from "./MinistryLog.vue?vue&type=script&lang=js&"
export * from "./MinistryLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports